import React, { useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import relationshipLabels from "../../../src/assets/data/relationship-labels.json";

import GlobalData from '../../context/globaldata';

import Button from "../../components/Button/Button";
import StarRating from "../../components/StarRating/StarRating";

export default function Result(props: any) {
  const history = useHistory();
  const context = useContext(GlobalData);

  const renderTypes = () => {
    const types = [];
    // let typeIndex = 0;
    for (const type in props.result.type) {
      if (props.result.type[type]) {
        types.push(type.charAt(0).toUpperCase() + type.slice(1));
      }

      // typeIndex++;
    }

    return types.join(", ");
  };

  return (
    <li className={`rate-requests__item ${props.result.status?.inactive ? "is-inactive" : ""}`}>
      <div className="rate-requests__column supplier-name">
        <Link className="result__anchor" to={`suppliers/${ props.result.uid }`}>
          { props.result.relationship > 0 &&
            <>
              <ReactTooltip place="top" effect="solid" delayShow={500} />
              <div className="result__relationship" data-tip={ relationshipLabels[props.result.relationship].label }>
                { props.result.relationship }
              </div>
            </>
          }
          <div className="result__content">
            { props.result.alias ? props.result.alias : props.result.car.Client }
            { props.result.subtitle && (
              <div className="result__subtitle result__subtitle--warning">
                <span>{ props.result.subtitle }</span>
              </div>
            ) }
          </div>
        </Link>
      </div>

      <div className="rate-requests__column supplier-location">
      <span>{ props.result.car.CompanyAddress?.GENCITY }, { props.result.car.CompanyAddress?.GENLAND }</span>
      </div>
      <div className="rate-requests__column supplier-types">
        { renderTypes() }
      </div>
      <div className="rate-requests__column supplier-rating">
        <StarRating rating={ props.result.rating } />
      </div>
      <div className="rate-requests__column supplier-action">
        { context.currentUser.custom?.admin && <Button onClick={ () => history.push(`suppliers/${ props.result.uid }?edit=true`) } variant="ghost">View supplier</Button> }
      </div>
    </li>
  )
}
